import { Pipe, PipeTransform, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Pipe({ name: 'filterByType' })
export class FilterByTypePipe implements PipeTransform {
    transform(data: Array<any>, type:String):Array<any> {
        return data.filter(i => i.meta.obj_type === type)
    }
}

@Pipe({ name: 'filterOutType' })
export class FilterOutTypePipe implements PipeTransform {
    transform(data: Array<any>, type:Array<string>):Array<any> {
        return data.filter(i => type.indexOf(i.meta.obj_type) < 0)
    }
}

@Pipe({ name: 'removeEmpty' })
export class RemoveEmptyRowsPipe implements PipeTransform {
    transform(data: Array<any>, type:Array<string>):Array<any> {
        return data.filter(i => i.meta.total_count && i.meta.total_count > 0)
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/filter.pipe.ts